import React, { useState, useRef, useEffect } from 'react';
import { initiateCoverLetterQA } from '../../services/actions/actions';
import { useDispatch } from 'react-redux';
import { Redirect, useHistory, useParams } from 'react-router';
import {  TPLS_COLOR, TPLTS, DEFAULT_VARIANT_COLOR, COOKIE_DOMAIN, COVERLETTER_EXPERIENCE, COVERLETTER_CHOOSE_TEMPLATE, COVERLETTER_CUSTOMIZE, DEFAULT_COVERLETTER_TEMPLATE_COLOR } from '../../constants/constants';
import './../../assets/scss/app/blocks/choose-template.scss';
import ListTemplate from './ListTemplate';
import { ChromePicker } from 'react-color';
import Loader from '../../images/spinner.svg';
import RainblowPicker from '../../assets/images/ranbow-01.svg';
import Splash from '../common/Splash';
import jsCookie from 'js-cookie';
const ChooseTemplate = (props) => {
    // const history = useHistory();
    const [skip, setSkip] = useState(false);
    const [next, setNext] = useState(false);
    const dispatch = useDispatch();
    const ddRef = useRef();
    const params = useParams()
    const [color, setColor] = useState('');
    const [selectedTpl, setSelectedTpl] = useState(false);
    const [selectedColor, setSelectedColor] = useState(false);
    const [redirectTo, setRedirectTo] = useState(false);
    const [singleResume, setSingleResume] = useState('');
    const [customColor, setCustomColor] = useState('');
    const [toggleColorPicker, setToggleColorPicker] = useState(false);
    const updateCustomColor = (color_code) => {
        setCustomColor(color_code);
    }

    const getStaticTemplate = (id) => {
        let temp = document.getElementById('static-' + id);
        setSingleResume(temp.innerHTML);
        setTimeout(() => {
            document.getElementById('resume-page').innerHTML = temp.innerHTML;
        }, 250);
    }

    const onClickOutside = React.useCallback((e) => {
        let wrap = e.target.className;
        if (wrap.length) {
            setToggleColorPicker(false);
        }
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ddRef.current && !ddRef.current.contains(event.target)) {
                onClickOutside && onClickOutside(event);
            }
        };
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, [onClickOutside]);
    
    useEffect(() => {
        if(skip || next){
        const req4rm = localStorage.getItem('cl_builder')
        if(req4rm){
            //if templat data is saveded save and move directly to first landing page
            // const lcolor = localStorage.getItem('cl_color')
            // const lcustomColor = localStorage.getItem('cl_custom_color');
            // const ltpl = localStorage.getItem('cl_tpl');
            // jsCookie.remove('current_letter', { domain: COOKIE_DOMAIN, path: "/" });
            // dispatch(initiateCoverLetterQA(lcustomColor , lcolor , ltpl, userExperience))
            if(next && selectedTpl) {
                //Dont set for Skip button
                localStorage.setItem('cl_tpl', selectedTpl)
                localStorage.setItem('cl_color', selectedColor)
                localStorage.setItem('cl_custom_color', customColor)
            }
            setRedirectTo(COVERLETTER_EXPERIENCE);
            //Clean local storage otherwise it might create problem with other workflow
        } else {
            const ltpl = localStorage.getItem('cl_tpl');
            jsCookie.remove('current_letter', { domain: COOKIE_DOMAIN, path: "/" });
            dispatch(initiateCoverLetterQA(customColor, color, selectedTpl, params.exp))
            setRedirectTo(COVERLETTER_CUSTOMIZE)
        }
            history.pushState(null, COVERLETTER_CHOOSE_TEMPLATE);
        }
        // next && save()
      }, [skip, next]);
      useEffect(() => {
        //browser issue, page not opening at top
        window.scrollTo(0, 0)
        //Set default if component loading thru landing page 
        const req4rm = localStorage.getItem('cl_builder')
            if(req4rm){
                const lcolor = localStorage.getItem('cl_color')
                const lcustomColor = localStorage.getItem('cl_custom_color');
                const ltpl = localStorage.getItem('cl_tpl');
                setCustomColor(lcustomColor)
                setColor(lcolor)
            }
      },[]);  
    //const [templateByJobCategory, setTemplateByJobCategory] = useState(['blank']);
    if (redirectTo) return <Redirect to={redirectTo} />

    return (<>
        <Splash cssClass={'fullwidth mt'} />
        <div className="choose-pre-template choose-pre-cover-letter">
            <div className="block">
                <div className="choose-pre-cover-letter-header">
                    <h1>Choose Your Template</h1>
                    <p className="light-color">
                    Select a template and customize the color.
                    </p>
                    <div className="color-selector-main">
                        <div id="mainForm" className="mainForm-screen">
                            {TPLS_COLOR.length ? (
                                <ul className="color-selector">
                                    <li className="item">
                                        {/* <label title="" className="label">
                                            <input
                                                type="radio"
                                                name="select-color"
                                                value={""}
                                                onChange={() => {
                                                    setColor("");
                                                    setCustomColor("");
                                                    gaTrack('RB App', `Editor`, `Choose Template: Change Color`);
                                                    ga4Track('app_editor_choose_template_change_color', 'RB App', 'Choose Template: Change Color');
                                                }}
                                                checked={customColor ? 'checked' : ''}
                                            />
                                            <span className={`color-selector-radio border`}>
                                                <i className="no-color"></i>
                                            </span>
                                        </label> */}
                                        <span 
                                            className={`color-selector-radio border`}
                                            onClick={() => {
                                                setColor("");
                                                setCustomColor("");
                                                gaTrack('RB App', `Editor`, `Choose Template: Change Color`);
                                                ga4Track('app_editor_choose_template_change_color', 'RB App', 'Choose Template: Change Color');
                                            }}
                                        >
                                            <i className="no-color"></i>
                                        </span>
                                    </li>
                                    {TPLS_COLOR.map((color, index) => {
                                        return (
                                            <li className={`item` + index} key={index}>
                                                {/* <label title="" className="label">
                                                    
                                                    <input
                                                        type="radio"
                                                        name="select-color"
                                                        value={color.id}
                                                        onChange={() => {
                                                            setCustomColor(color.color_code)
                                                            gaTrack('RB App', `Editor`, `Choose Template: Change Color`);
                                                            ga4Track('app_editor_choose_template_change_color', 'RB App', 'Choose Template: Change Color');
                                                            // localStorage.setItem('selected_color', color)
                                                        }}
                                                    />
                                                    <span
                                                        className={`color-selector-radio `}
                                                        style={{backgroundColor: color.color_code}}
                                                    ></span>
                                                </label> */}
                                                <span
                                                    className={`color-selector-radio `}
                                                    style={{backgroundColor: color.color_code}}
                                                    onClick={() => {
                                                        setCustomColor(color.color_code)
                                                        gaTrack('RB App', `Editor`, `Choose Template: Change Color`);
                                                        ga4Track('app_editor_choose_template_change_color', 'RB App', 'Choose Template: Change Color');
                                                        // localStorage.setItem('selected_color', color)
                                                    }}
                                                    data-acsb-navigable="true"></span>
                                            </li>
                                        );
                                    })}
                                    <li className="multi-color-selector">
                                        <span className="spearator-text">Custom:</span>
                                        <div className="multiple-color" onClick={() => {
                                            setToggleColorPicker(true);
                                        }}>
                                            <span className="rainblow-picker">
                                                {!customColor ? <RainblowPicker /> : <i className="color-square" style={{ backgroundColor: customColor ? customColor : (DEFAULT_COVERLETTER_TEMPLATE_COLOR[selectedTpl] ?? '#B01C23') }}></i>}
                                            </span>
                                            {toggleColorPicker ? <div className="chrome-picker" ref={ddRef}> <ChromePicker
                                                color={customColor ? customColor : (DEFAULT_COVERLETTER_TEMPLATE_COLOR[selectedTpl] ?? '#588981')}
                                                onChange={(e) => { setCustomColor(e.hex) }}
                                                onChangeComplete={(e) => {
                                                    setColor('');
                                                    setCustomColor(e.hex);
                                                    updateCustomColor(e.hex);
                                                    gaTrack('RB App', `Editor`, `Choose Template: Change Color`);
                                                    ga4Track('app_editor_choose_template_change_color', 'RB App', 'Choose Template: Change Color');
                                                }}
                                                disableAlpha={true}
                                            /> </div> : ''}
                                            <label htmlFor="input-color-picker">{customColor ? customColor : (DEFAULT_COVERLETTER_TEMPLATE_COLOR[selectedTpl] ?? '#588981')}</label>
                                        </div>
                                    </li>
                                </ul>
                            ) : (
                                ""
                            )}
                            <div className="choose-screen-ctrls">
                                <button className="round-btn" onClick={() => setSkip(!skip)}><span>Skip for now</span><i className="arrow icon-double-arrow-right"></i></button>
                                <button className="round-btn active" onClick={() => setNext(!next)} ><span>Next</span><i className="arrow-bar-right"></i></button>
                            </div>
                        </div>
                    </div>  
                </div>               
                <div className="select-template">
                    <ListTemplate
                        templates={TPLTS
                            .filter(t => t.hasOwnProperty('coverletter') && t.coverletter)
                            .sort((a, b) => (b?.coverletter_listing_priority - a.coverletter_listing_priority))}
                        color={color}
                        customColor={customColor}
                        headerColor={''}
                        page={"choose-template"}
                        rows={2}
                        singleResume={singleResume}
                        setSingleResume={(e) => {
                            getStaticTemplate(e);
                        }}
                        selectedTpl = {selectedTpl}
                        setSelectedTpl = {setSelectedTpl}
                        selectedColor = {selectedColor}
                        setSelectedColor = {setSelectedColor}
                    />
                </div>
            </div>
            {/* <div className="skip-bar">
                <div className="skip-link" onClick={() => { 
                    jsCookie.remove('current_letter', { domain: COOKIE_DOMAIN, path: "/" });
                    dispatch(initiateCoverLetterQA(customColor , color , '', params.exp))
                    setRedirectTo(COVERLETTER_CUSTOMIZE)
                    }}>Skip for Now </div>
            </div> */}

            {singleResume ? <div id="rightEditor" className={`right right__fullscreen`} onClick={(e) => { setSingleResume() }}>
                {singleResume ? <div className="close-wrap">
                    <i onClick={() => { setSingleResume() }}>Close</i>
                </div> : ''}
                <div id="resume-download">
                    <div className="paper preview-resume" id="preview-resume">
                        <div id="resume-page" className="page">
                            <Loader />
                        </div>
                    </div>
                </div>

            </div> : ''}

        </div>
    </>);
}


export default ChooseTemplate;